import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, switchMap, tap } from 'rxjs';
import { ROUTE } from '../../models';
import { Router } from '@angular/router';
import {
  ContractStatus,
  getContracts,
  getContractsActionState,
  getMissingConsentsActionState,
  getPersonalData,
  getPersonalDataActionState,
  LoadContracts,
  LoadPersonalData,
} from '@resident-nx/shared';

export const ContractGuard = (checkForExpiration?: boolean) => {
  return () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(getMissingConsentsActionState).pipe(
      filter(consentState => consentState.done),
      switchMap(() =>
        combineLatest([
          store.select(getContractsActionState),
          store.select(getPersonalDataActionState),
        ])
      ),
      tap(([contractState, personalDataState]) => {
        if (!contractState.pending && !contractState.done) {
          store.dispatch(LoadContracts({}));
          store.dispatch(LoadPersonalData());
        }
        if (!personalDataState.pending && !personalDataState.done) {
          store.dispatch(LoadPersonalData());
        }

        if (personalDataState.error) {
          router.navigate(['logout']);
        }
      }),
      filter(([contractState, personalDataState]) => contractState.done && personalDataState.done),
      switchMap(() => store.select(getPersonalData)),
      switchMap(personalData =>
        store.select(getContracts).pipe(
          map(contracts => {
            if (!contracts.length && !checkForExpiration) {
              router.navigate([ROUTE.NEWS]);
              return true;
            }

            if (
              checkForExpiration &&
              contracts.length &&
              contracts.every(contract => contract.status === ContractStatus.EXPIRED) &&
              !personalData?.cooperativeData?.activeMembership
            ) {
              router.navigate(['unauthorized-user']);
              return true;
            }

            return true;
          })
        )
      )
    );
  };
};
